import { render, staticRenderFns } from "./UpdateEmployeesDetails.component.html?vue&type=template&id=2eea99ea&scoped=true&"
import script from "./UpdateEmployeesDetails.component.ts?vue&type=script&lang=ts&"
export * from "./UpdateEmployeesDetails.component.ts?vue&type=script&lang=ts&"
import style0 from "./UpdateEmployeesDetails.component.scss?vue&type=style&index=0&id=2eea99ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea99ea",
  null
  
)

export default component.exports